import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';

import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import {ErrorAlert} from '../common/ErrorAlert';
import {ErrorResponse, SaveInventoryStockItemRequest, Warehouse} from '../api/dtos/dtos';
import InventoryStockItemForm from './InventoryStockItemForm';
import furoApi from '../api/FuroApi';
import {showSaveConfirm, showSaveSuccessNotification} from '../utils/dialogs';
import * as paths from '../paths';
import {CURRENCY_EUR} from '../utils/currency-utils';
import {now, toIsoDateString} from '../utils/date-utils';

interface State {
  error?: ErrorResponse;
  warehouses: Warehouse[];
}

class CreateInventoryStockItemPage extends React.Component<RouteComponentProps<paths.IdPageUrlParams>, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {
    warehouses: [],
  };

  public componentDidMount() {
    this.loadWarehouses();
  }

  public render() {
    const {warehouses} = this.state;
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <InventoryStockItemForm
          warehouses={warehouses}
          onRefreshExchangeRate={this.refreshExchangeRate}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
        />

        <ErrorAlert style={{marginTop: '16px'}} error={this.state.error}/>
      </>
    );
  }

  private getInventoryStockId = (): number => {
    return Number(this.props.match.params.id);
  };

  private onFormSubmit = (request: SaveInventoryStockItemRequest) => {
    showSaveConfirm(() => this.save(request));
  };

  private onFormCancel = () => {
    this.props.history.goBack();
  };

  private save = (request: SaveInventoryStockItemRequest) => {
    const inventoryStockId = this.getInventoryStockId();
    const promise = furoApi.inventoryStockItems.create({...request, inventoryStockId})
      .then(() => {
        showSaveSuccessNotification();
        this.props.history.goBack();
      })
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private refreshExchangeRate = (): Promise<number | void> => {
    const promise = furoApi.currency.getRate(CURRENCY_EUR, toIsoDateString(now()))
      .then(response => response.rate)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
    return promise;
  };

  private loadWarehouses = () => {
    const promise = furoApi.warehouses.getWarehouses()
      .then((warehouses) => this.setState({warehouses, error: undefined}))
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default withRouter(CreateInventoryStockItemPage);




// WEBPACK FOOTER //
// ./src/inventory-stock-details/CreateInventoryStockItemPage.tsx